// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2mtsL","colMin":"styles_colMin__OTJhz","colCheckbox":"styles_colCheckbox__2Bc_A"};